import { createSelectors } from '@mri-platform/shared/entity';
import { Client } from '../../models';

export const clientSelectors = createSelectors(Client);
